import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";


const LISTADO_PRECIOS = 'LISTADO_PRECIOS';
const GUARDAR_PRECIOS = 'GUARDAR_PRECIOS';
const DETALLE_PRODUCTOS = 'DETALLE_PRODUCTOS';
const LOADER = 'LOADER';
const PARAMETRO = 'PARAMETRO';
const MODULO = 'MODULO';
const LISTADO = 'LISTADO';
const CANTIDAD_LISTA =  'CANTIDAD_LISTA';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let modulo = 'INV'
    const params = { id, modulo };
    dispatch(setLoader(true));
    api.get('/listado_precios', params).then((response)=>{
        dispatch({ type: LISTADO_PRECIOS, data: response });
        dispatch({ type: CANTIDAD_LISTA, cantLista: response.length });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar precios',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroListado = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormListadoPreciosINV.values;
    const detalle = localStorage.getItem('id_detalle_listado_precios_inv');
    const formData = {
        nombre_lista: data.nombre_lista,
        producto: data.producto.value,
        precio: data.precio,
        empresa: id_emp[5],
        modulo: 'INV',
        detalle: detalle
    }
    dispatch(setLoader(true));
    api.post('/listado_precios/', formData).then((response) => {
        if (detalle){
            dispatch(initializeForm('FormListadoPreciosINV', response));
            dispatch(leerDetalleProductos(response.id));
        }else{
            dispatch(initializeForm('FormListadoPreciosINV', response));
            localStorage.setItem('id_detalle_listado_precios_inv', response.id);
            dispatch(leerDetalleProductos(response.id));
        }
        NotificationManager.success(
            'Producto ingresado correctamente',
            'Exito',
            3000
        );
        
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}           

export const modificarListado = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormListadoPreciosINV.values;
    const id = datos.id;
    const formData = {
        id: id,
        nombre_lista: datos.nombre_lista,
    }
    dispatch(setLoader(true));
    api.put(`/listado_precios/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Listado modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/inventario/${id_emp[5]}/listado_precios`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/listado_precios/${id}`).then((response) => {
        dispatch(initializeForm('FormListadoPreciosINV', response));
        localStorage.setItem('id_detalle_listado_precios_inv', response.id);
        dispatch(leerDetalleProductos(response.id));
    }).catch(()=>{
        NotificationManager.error(
            'Ocurrió un error al consultar lista de precios',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}


export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = {id}
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};


export const listarProductos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/producto/empresa_productos_cod',params).then(data=>{
        const list_producto = [];
        if(data){
            data.forEach(item=>{
                if (item.tipo === 'P'){
                    list_producto.push({
                        value: item.id,
                        label: item.SKU + ' / ' + item.producto
                    })
                }
            })
        }
        return list_producto ;
    }).catch((error)=>{
        return [];
    })
}

const leerDetalleProductos = id => (dispatch) => {
    api.get(`/listado_precios_detalle/${id}`).then((response)=>{
        dispatch({ type: DETALLE_PRODUCTOS, detalleProducto: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

const eliminarLineaProducto = id => (dispatch) => {
    const detalle = localStorage.getItem('id_detalle_listado_precios_inv');
    dispatch(setLoader(true));
    api.eliminar(`/listado_precios_detalle/${id}`).then(() => {
        dispatch(leerDetalleProductos(detalle));
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listarClientes = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/cliente/empresa_clientes_cod',params).then(data=>{
        const list_cliente = [];
        if(data){
            data.forEach(item=>{
                list_cliente.push({
                    value: item.id,
                    label: item.identificador + ' ' + item.nombre
                })
            })
        }
        return list_cliente ;
    }).catch((error)=>{
        
        return [];
    })
}

export const listPrecios = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/listado_precios/empresa_listado',params).then(data=>{
        const list_precio = [];
        if(data){
            data.forEach(item=>{
                list_precio.push({
                    value: item.id,
                    label: item.nombre_lista
                })
            })
        }
        return list_precio ;
    }).catch((error)=>{
        
        return [];
    })
}

export const actions = {
    listar,
    registroListado,
    modificarListado,
    leer,
    getModulo,
    parametrosEmpresa,
    listarProductos,
    leerDetalleProductos,
    eliminarLineaProducto,
    listarClientes,
    listPrecios,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_PRECIOS]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [DETALLE_PRODUCTOS]: (state, { detalleProducto }) => {
        return {
            ...state,
            detalleProducto,
        };
    },
    [GUARDAR_PRECIOS]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [LISTADO]: (state, { lista }) => {
        return {
            ...state,
            lista,
        };
    },
    [CANTIDAD_LISTA]: (state, { cantLista }) => {
        return {
            ...state,
            cantLista,
        };
    },
};

export const initialState = {
    loader: false,
    lectura: [],
    listaP: [],
    datos: [],
    modulo: [],
    lista: [],
    detalleProducto: [],
    data: [],
    page: 1,
    cantLista: []
};

export default handleActions(reducers, initialState)